module.exports = __webpack_public_path__ + "static/media/dose-reference-levels-ct-scanner.c003ee8a.svg";